/* tslint:disable */

import AppConfig from "../configs/AppConfig"
import { IBookingTrip } from "src/redux/sagaBooking/IBooking"
import * as R from "ramda"
import * as moment from "moment"
import * as queryString from "query-string"
import Swal from "sweetalert2"

export function getDocumentRoot(): string {
  let url: string
  if (process.env.PUBLIC_URL) {
    url = process.env.PUBLIC_URL
  } else {
    const arr = window.location.href.split("/")
    url = arr[0] + "//" + arr[2]
  }
  if (url.slice(-1) !== "/") {
    url += "/"
  } // add a trailing slash
  return url
}

export function getCurrentPath(): string {
  const documentRoot = getDocumentRoot()
  const path = window.location.href.replace(documentRoot, "").trim()
  return path
}

export function getLangInPath(): string {
  const path = getCurrentPath()
  const pathArray: string[] = path.split("/")
  const langInPath = pathArray[0].split("?")[0]
  return langInPath ? langInPath : AppConfig.defaultLanguage
}

export function checkIsMobileDevice() {
  let isMobile = false
  if (
    /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
      navigator.userAgent
    ) ||
    /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
      navigator.userAgent.substr(0, 4)
    )
  ) {
    isMobile = true
  }
  return isMobile
}

export function getBase64(img, callback) {
  const reader = new FileReader()
  reader.addEventListener("load", () => callback(reader.result))
  reader.readAsDataURL(img)
}

export function generateRandom() {
  return (
    Math.random()
      .toString(36)
      .substring(2, 15) +
    Math.random()
      .toString(36)
      .substring(2, 15)
  )
}

export function generateBookingQueryString(data: IBookingTrip) {
  if (data === undefined || !data) {
    return null
  }
  let result = ""
  result = R.concat(result, `id=${data.id}`)
  result = R.concat(result, `&type=${data.type}`)
  result = R.concat(result, `&status=${data.status}`)

  result = R.concat(result, `&from=${data.from}`)
  result = R.concat(result, `&fromLat=${data.fromLatLng.lat}`)
  result = R.concat(result, `&fromLng=${data.fromLatLng.lng}`)
  result = R.concat(
    result,
    `&departureDate=${moment(data.departureDate).format("DD/MM/YYYY-HH:mm")}`
  )

  result = R.concat(result, `&destination=${data.destination}`)
  result = R.concat(result, `&destinationLat=${data.destinationLatLng.lat}`)
  result = R.concat(result, `&destinationLng=${data.destinationLatLng.lng}`)
  if (data.type === "ROUND_TRIP") {
    result = R.concat(
      result,
      `&returnDate=${moment(data.returnDate).format("DD/MM/YYYY-HH:mm")}`
    )
  }

  result = R.concat(result, `&busType=${data.busType}`)
  result = R.concat(result, `&category=${data.category}`)
  result = R.concat(result, `&quantity=${data.quantity || 0}`)
  result = R.concat(result, `&passengers=${data.passengers || 0}`)
  return encodeURI(result)
}

export function GetDefaultIBookingTrip() {
  const result = {
    id: 0,
    type: "ROUND_TRIP",
    status: "PENDING",
    from: null,
    fromLatLng: null,
    departureDate: new Date(),
    destination: null,
    destinationLatLng: null,
    returnDate: new Date(),
    busType: 1,
    quantity: 1,
    passengers: 20
  } as IBookingTrip
  return result
}

export function ConvertParamsToIBookingTrip(inputData) {
  if (!inputData || inputData.length <= 0) {
    // return default IBookingTrip
    return GetDefaultIBookingTrip()
  }
  const params = queryString.parse(inputData)
  const result = {
    id: params.id,
    type: params.type,
    status: params.status,
    from: params.from,
    fromLatLng: {
      lat: params.fromLat ? +params.fromLat : 0,
      lng: params.fromLng ? +params.fromLng : 0
    },
    departureDate: moment(params.departureDate, "DD/MM/YYYY-HH:mm").toDate(),
    destination: params.destination,
    destinationLatLng: {
      lat: params.destinationLat ? +params.destinationLat : 0,
      lng: params.destinationLng ? +params.destinationLng : 0
    },
    returnDate: params.returnDate
      ? moment(params.returnDate, "DD/MM/YYYY-HH:mm").toDate()
      : null,
    busType: params.busType && params.busType !== "0" ? +params.busType : 0,
    quantity: Math.ceil(
      params.quantity && params.quantity !== "0"
        ? +params.quantity
        : params.passengers && params.passengers !== "0"
        ? +params.passengers / 40
        : 1
    ),
    passengers: params.passengers ? +params.passengers : 50,
    category: params.category ? params.category : "BUS",
    day:
      params.type === "ONEWAY_TRIP"
        ? 1
        : moment(params.returnDate, "DD/MM/YYYY-HH:mm").diff(
            moment(params.departureDate, "DD/MM/YYYY-HH:mm"),
            "days"
          )
  }
  return result
}

export function validateEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(email).toLowerCase())
}
export function confirmClearCart(title, content) {
  Swal.fire(title, content, "success")
}

export function messageInfo(title, content) {
  Swal.fire(title, content, "info")
}

export function generateQuickGuid() {
  return (
    Math.random()
      .toString(36)
      .substring(2, 15) +
    Math.random()
      .toString(36)
      .substring(2, 15)
  )
}

export function buildUrl(path: string): string {
  if (path.trim()[0] === "/") {
    // remove starting slash
    path = path.trim().substr(1)
  }
  const currentPathArr = getCurrentPath().split("/")
  return (
    "/" +
    [
      currentPathArr[0] /*this is office*/,
      currentPathArr[1] /*this is language*/,
      path
    ].join("/")
  )
}

export function generateBGForTag(tagName: string) {
  switch (tagName) {
    case "Standard Class":
      return "hiso-bus-rental-bg-color-orange"
    case "Premium Class":
      return "hiso-bus-rental-bg-color-gold"
    case "Business Class":
      return "hiso-bus-rental-bg-color-blue"
    default:
      return "hiso-bus-rental-bg-color-orange"
  }
}

export function formatIconName(iconName: string) {
  return iconName
    .split(" ")
    .join("-")
    .toLocaleLowerCase()
}

export function successModal(title: string, text: string) {
  Swal.fire(title, text, "success")
}



// WEBPACK FOOTER //
// ./src/helpers/utility.ts